import { FC, useMemo } from "react";
import { useTheme } from "@mui/material/styles";
import { SmallLineChart } from "./SmallLineChart";

export type RatingPoint = {
  date: string;
  learnerRating?: number | null;
  coachRating?: number | null;
};

export interface CompetencyRatingsChartProps {
  data: RatingPoint[];
  height?: number;
  onClickDot?: (data: any) => void;
}

/**
 * CompetencyRatingsChart
 *
 * Reuses SmallLineChart to show learner and coach ratings over time
 * for a given competency/ITER requirement.
 */
export const CompetencyRatingsChart: FC<CompetencyRatingsChartProps> = ({
  data,
  height = 180,
  onClickDot,
}) => {
  const theme = useTheme();
  
  const series = useMemo(
    () => [
      {
        name: "Learner rating",
        color: theme.palette.primary.main,
        data: data
          .filter(
            (p) => p.learnerRating !== null && p.learnerRating !== undefined,
          )
          .map((p) => ({
            date: p.date,
            value: p.learnerRating as number,
          })),
      },
      {
        name: "Coach rating",
        color: theme.palette.secondary.main,
        data: data
          .filter(
            (p) => p.coachRating !== null && p.coachRating !== undefined,
          )
          .map((p) => ({
            date: p.date,
            value: p.coachRating as number,
          })),
      },
    ],
    [data, theme],
  );

  return (
    <SmallLineChart
      series={series}
      height={height}
      onClickDot={onClickDot}
    />
  );
};


